import React from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import { Container, Row, Col } from 'react-bootstrap'
import HR from '../Components/HR'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { removeText } from '../Utils/helpers';
import { adjustData } from '../Data/data';

const FormTable = (props) => {
    const handleRemove = (event, type, index, list) => {
        if(event.code === "Enter") {
            removeText(type, index, list)
        }
    }

    return (
        <Container>
            <Row>
                <Col className="mb-2">
                    <Card border='dark'>
                        <Card.Body className='adjustTable'>
                            <Card.Title title={props.plusList.length + '/3 valintaa'} tabIndex={0} >{adjustData.tableHeaders.posHeader}</Card.Title>
                            <HR />
                            <ListGroup variant="flush">
                                {props.plusList.map((item, index) => {
                                   return <ListGroup.Item key={'plus' + index} tabIndex={0} >{item}<span className="float-end text-danger" >
                                       <i className="removebtn" onClick={() => removeText('+', index, props.setPlusList)} onKeyPress={(e) => handleRemove(e, '+', index, props.setPlusList)} tabIndex={0} ><FontAwesomeIcon icon={faTimesCircle} /></i>
                                       </span></ListGroup.Item>
                                })}
                            </ListGroup>
                        </Card.Body>
                    </Card>
                </Col>
                <Col className="mb-2">
                    <Card border='dark'>
                        <Card.Body className='adjustTable'>
                            <Card.Title title={props.minusList.length + '/3 valintaa'} tabIndex={0} >{adjustData.tableHeaders.negHeader}</Card.Title>
                            <HR />
                            <ListGroup variant="flush">
                                {props.minusList.map((item, index) => {
                                   return <ListGroup.Item key={'minus' + index} tabIndex={0} >{item}<span className="float-end text-danger" >
                                   <i className="removebtn" onClick={() => removeText('-', index, props.setMinusList)} onKeyPress={(e) => handleRemove(e, '-', index, props.setMinusList)} tabIndex={0} ><FontAwesomeIcon icon={faTimesCircle} /></i>
                                   </span></ListGroup.Item>
                                })}
                            </ListGroup>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default FormTable;